var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrequencyVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#0A4FB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9713 39.235L82.2076 33.9682L77.4704 29.2035L71.7483 34.9555C68.2306 32.8327 64.13 31.5859 59.7345 31.5859C46.8061 31.5859 36.2832 42.1666 36.2832 55.1735C36.2832 68.1803 46.8061 78.7611 59.7345 78.7611C72.6629 78.7611 83.1859 68.1803 83.1859 55.1735C83.1832 49.2632 80.9639 43.5714 76.9713 39.235ZM59.7345 72.0217C50.4981 72.0217 42.9836 64.4636 42.9836 55.1735C42.9836 45.8833 50.4981 38.3252 59.7345 38.3252C68.971 38.3252 76.4855 45.8833 76.4855 55.1735C76.4855 64.4636 68.971 72.0217 59.7345 72.0217Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2837 45.2507H63.0093V58.4661H56.2837V45.2507ZM52.9208 22.1239H66.3722V28.7316H52.9208V22.1239ZM19.2925 38.6431H32.7438V45.2507H19.2925V38.6431ZM19.2925 65.0738H32.7438V71.6814H19.2925V65.0738ZM15.9297 51.8584H29.3474V58.4661H15.9297V51.8584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequencyVisit);
export default __webpack_public_path__ + "static/media/frequency_visit.116709bfabdf77424870e47c79ed1a4f.svg";
export { ForwardRef as ReactComponent };